// @flow

import React from 'react';
import { capitalize } from 'lodash';
import { connect } from 'react-redux';

import { GET_HELP_CTA } from '@zapier/product-get-help';

import LoginForm from 'app/login/components/LoginForm';

const Description = () => (
  <span>
    <p>Thanks for signing up. We're happy you're here!</p>
    <p>
      We just sent you an email with a link you can use to set a password and
      activate your Zapier account. Click on that to start automating!
    </p>
    <p>
      Never received the link or it expired?{' '}
      <a href="/app/contact-us?topic=account&account=other&answer[contact]=yes">
        {capitalize(GET_HELP_CTA)}
      </a>
      .
    </p>
  </span>
);

const mapStateToProps = () => {
  return {
    title: 'Activate Your Account',
    description: <Description />,
    shouldShowSubmitButton: false,
    shouldShowLoginForm: true,
  };
};

const mapDispatchToProps = () => {
  return {};
};

const ActivateLinkFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);

export default ActivateLinkFormContainer;
